class ConfigEnvironment {
    authToken = '';
    language = '';
    manufacturer = '';
    platform = '';
    playerId = '';
    viewerId = '';
    personalisationEnabled = null;

    constructor() {
        Object.seal(this);
    }
}

export default ConfigEnvironment;
